import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./features/auth/context/AuthContext";
import { ToastProvider, TooltipProvider, DialogHost, ErrorBoundary } from "./shared/ui";
import { AppRoutes } from "./app/routes";

/**
 * Jewelitt Vault root: router + auth + global providers. The viewer iframe is
 * mounted per-route by the Studio/Band pages (via ViewerHost), not here.
 *
 * The ErrorBoundary is the last-resort backstop: before it existed, any
 * render-time exception unmounted the whole SPA to a blank page. Routes that
 * hold unsaved work (the editors) wrap themselves more tightly in routes.tsx so
 * a failure there does not take the surrounding chrome down with it.
 */
export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <TooltipProvider>
            <ErrorBoundary>
              <AppRoutes />
            </ErrorBoundary>
            <DialogHost />
          </TooltipProvider>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
